// Formular-Vorlage (Kraiss & Friz) darf sich nicht ändern: Zusatzartikel (z. B. ARKUF 18) stehen in der App
// in der Artikelliste, das PDF druckt sie aber nur — wenn bestellt — in den freien Zeilen unter der Liste,
// so wie sie früher von Hand eingetragen wurden. gasPdf.ts selbst bleibt unverändert.
import type { GasEinstellungen } from './api';

export function pdfEinstellungen(e: GasEinstellungen): GasEinstellungen {
  return { ...e, artikel: e.artikel.filter((a) => !a.zusatz).map(({ zusatz: _z, ...a }) => a) };
}
